var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.103C0 9.59215 1.21185 10.804 2.701 10.804C3.41586 10.804 4.0623 10.5204 4.54578 10.0657L9.93968 13.1485C9.92347 13.2655 9.90366 13.3826 9.90366 13.505C9.90366 14.9941 11.1155 16.206 12.6047 16.206C14.0938 16.206 15.3057 14.9941 15.3057 13.505C15.3057 12.0158 14.0938 10.804 12.6047 10.804C11.8898 10.804 11.2434 11.0876 10.7599 11.5423L5.36599 8.46043C5.38219 8.34249 5.402 8.22544 5.402 8.103C5.402 7.98055 5.38219 7.86351 5.36599 7.74557L10.7599 4.66373C11.2434 5.11839 11.8898 5.402 12.6047 5.402C14.0938 5.402 15.3057 4.19015 15.3057 2.701C15.3057 1.21185 14.0938 0 12.6047 0C11.1155 0 9.90366 1.21185 9.90366 2.701C9.90366 2.82344 9.92347 2.94049 9.93968 3.05843L4.54578 6.14027C4.0479 5.66731 3.38772 5.4031 2.701 5.402C1.21185 5.402 0 6.61385 0 8.103Z",
    fill: "#214ba5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.4f7b8f040ea684c334deb1d77c2f8cac.svg";
export { ForwardRef as ReactComponent };